import { object } from '@calendly/form/validation'
import { IconShield } from '@calendly/ui/components/glyphs/IconShield'

import {
  formatBuffersValues,
  getBuffersInitialValues,
  getEventLimitsInitialValues,
  getEventLimitsValidationSchema,
  getFormatEventLimitsValues,
} from 'components/event_type_edit'
import { PANELS } from 'constants/event_type_editor_panels'

// Mirrors features/event_type_editor/.../limits_and_buffers/utils.js
export const SCHEDULING_LIMITS_TAB_KEY = 'limits'

export const getValidationSchema = () => object({})
  .concat(getEventLimitsValidationSchema())

export const getInitialValues = (eventType) => ({
  ...getBuffersInitialValues(eventType),
  ...getEventLimitsInitialValues(eventType),
})

export const getFormatValuesToServerData = (eventType) => (values) => {
  const formatEventLimitsValues = getFormatEventLimitsValues(eventType)

  return {
    ...formatBuffersValues(values),
    ...formatEventLimitsValues(values),
  }
}

const getPanelFieldNames = () => Object.keys(getValidationSchema().fields)

export const getPanelFieldNamesForErrorRollup = getPanelFieldNames

export const schedulingLimitsTabDefinition = {
  key: SCHEDULING_LIMITS_TAB_KEY,
  label: 'Scheduling limits',
  icon: IconShield,
  subtitle: 'Buffers, limits',
  formKey: 'moreOptions',
  panelKeys: [PANELS.limitsAndBuffers],
  usesCustomPanel: true,
}

export const getSchedulingLimitsActiveTabConfig = (eventType) => ({
  fieldNames: getPanelFieldNamesForErrorRollup(),
  validationSchema: getValidationSchema(),
  formatPanelKeys: [PANELS.limitsAndBuffers],
  formatValuesToServerData: getFormatValuesToServerData(eventType),
})
